import React, { lazy, Suspense } from 'react';
import { createRoot} from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import './index.css';
import App from './App';

import OathPage from './Pages/OathPage'
import ErrorPage from './Pages/ErrorPage'
import AcademyPage from './Pages/AcademyPage';
import BlogPage from './Pages/BlogPage';
import RecapturePage from './Pages/Projects/REcapture';
import ScribeCardsPage from './Pages/Projects/ScribeCards';
import MerchPage from './Pages/MerchPage';
import EngineeringSprintsPage from './Pages/EngineeringSprintsPage';
import useConfig from './useConfig';

// Lazy so the page's text is only downloaded when SHOW_FRACTIONAL_CTO_PAGE is
// on, not shipped to every visitor in the main bundle.
const FractionalCtoPage = lazy(() => import('./Pages/FractionalCtoPage'));

// While the flag is off this is a 404, the same as any route that doesn't
// exist. Nothing renders until the config loads, so a hidden page can't flash.
const FractionalCtoRoute = () => {
  const config = useConfig();

  if (config === null) return null;
  if (!config.showFractionalCtoPage) {
    throw new Response('', { status: 404, statusText: 'Not Found' });
  }
  return <Suspense fallback={null}><FractionalCtoPage /></Suspense>;
};


const router = createBrowserRouter([{
  path: '/',
  element: <App />,
  errorElement: <ErrorPage />,
  children: [
    {
      index: true,
      element: <OathPage /> // TODO this needs to point to the homepage rather than the Oath
    },
    {
      path: '/academy',
      element: <AcademyPage />
    },
    {
      path: '/blog',
      element: <BlogPage />
    },
    {
      path: '/projects/scribe-cards',
      element: <ScribeCardsPage />
    },
    {
      path: '/projects/recapture',
      element: <RecapturePage />
    },
    {
      path: '/fractional-cto',
      element: <FractionalCtoRoute />
    },
    {
      path: '/engineering-sprints',
      element: <EngineeringSprintsPage />
    },
    {
      // Shows the drop or ComingSoon depending on SHOW_MERCH_PAGE, which the
      // server reads at runtime. See Pages/MerchPage.jsx.
      path: '/merch',
      element: <MerchPage />
    }
  ]
}])

const root = createRoot(document.getElementById("root"));
root.render(
  <>
    <RouterProvider router={router} />
  </>
);
